import React, { useEffect, useState } from "react";
import SmallButton from "../../components/Buttons/SmallButton";
import { SearchIcons } from "../../components/Icons";
import { CardButton } from "../../components/Card";
import BeneficiaryButton from "../../components/Buttons/BeneficiaryButton";
import { useDispatch } from "react-redux";
import { listBeneficiary } from "../../redux/actions/TRrequest/Beneficiary";
import ShowBeneficiaryModal from "../../components/Modals/Beneficiary/ShowBeneficiaryModal";
import AddBeneficiaryModal from "../../components/Modals/Beneficiary/AddBeneficiaryModal";
import EmptyBeneficiary from "../../components/Empty/EmptyBeneficiary";
import {
  BeneficiarySkeleton,
  CardButtonSkeleton,
} from "../../components/Skeleton";
import { setPageTitle } from "../../helper/metaDataHelper";
import { getModuleStatus } from "../../redux/actions/lookups/getModuleStatus";

const ManageBeneficiaries = () => {
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectBeneficiary, setSelectBeneficiary] = useState({});
  const [addBeneficiaryModalOpen, setaddBeneficiaryModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isBeneficiaryEmpty, setIsBeneficiaryEmpty] = useState(false);
  const [refreshBeneficiary, setRefreshBeneficiary] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setPageTitle("Manage Beneficiaries");
    dispatch(getModuleStatus({ module: "OpenPayd" }));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const GetBeneficiaries = async () => {
      try {
        // Fetch data
        setIsLoading(true);
        const res = await dispatch(listBeneficiary());
        if (res.length) {
          setBeneficiaries(res);
          setIsBeneficiaryEmpty(false);
        } else {
          setBeneficiaries([]);
          setIsBeneficiaryEmpty(true);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error in Manage Beneficiary useEffect:", error);
      }
    };
    if (refreshBeneficiary && addBeneficiaryModalOpen === false) {
      GetBeneficiaries();
      setRefreshBeneficiary(false);
    }
  }, [addBeneficiaryModalOpen, refreshBeneficiary, dispatch]);

  const filteredBeneficiaries = beneficiaries.filter(
    (account) =>
      account.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      account.account_number
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      account.swift_code.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <main>
      <div className="max-w-[1024px] mx-auto px-4 min-h-screen">
        <div className="flex flex-col sm:flex-row justify-center gap-3">
          {/* First sections */}
          <div className="md:w-[572px] w-full sm:flex-grow mb-6 sm:mb-0 space-y-4">
            <SmallButton cancel={true} text={"Close"} href={"/"} />
            <div className="page-title !text-3xl">
              Manage beneficiaries
            </div>

            <div className="flex items-center justify-center ">
              {!isBeneficiaryEmpty && (
                <div className="w-[572px]">
                  {/* Search input */}
                  <div className="search-input-wrapper px-3 py-1 rounded-full flex justify-start items-center">
                    <SearchIcons className="w-6 h-6 relative" />
                    <input
                      onChange={(e) => setSearchQuery(e.target.value)}
                      qurey={searchQuery}
                      placeholder="Search"
                      className="search-input"
                    />
                  </div>
                  {!isLoading ? (
                    <AddBeneficiaryModal
                      addBeneficiaryModalOpen={addBeneficiaryModalOpen}
                      setaddBeneficiaryModalOpen={setaddBeneficiaryModalOpen}
                      setRefreshBeneficiary={setRefreshBeneficiary}
                    >
                      <CardButton
                        title={"Add new beneficiary"}
                        subtitle={"Add new beneficiary to send money"}
                      />
                    </AddBeneficiaryModal>
                  ) : (
                    <div className="pt-4">
                    <CardButtonSkeleton />
                    </div>
                  )}
                  <hr className="my-3 border border-divider" />

                  {isLoading ? (
                    <BeneficiarySkeleton />
                  ) : filteredBeneficiaries.length ? (
                    filteredBeneficiaries.map((beneficiary) => (
                      <div
                        key={beneficiary.id}
                        onClick={() => {
                          setSelectBeneficiary(beneficiary);
                          setIsModalOpen(true);
                        }}
                      >
                        <BeneficiaryButton
                          beneficiaryName={beneficiary.name}
                          accountNumber={beneficiary.account_number}
                          iban={beneficiary.iban}
                          virtualBankBeneficiary={beneficiary.virtual_bank_beneficiary}
                        />
                      </div>
                    ))
                  ) : (
                    <div className="text-sm font-medium text-text-primary">
                      <p>
                        No beneficiary with this <b>{searchQuery}</b> name.
                      </p>
                    </div>
                  )}

                  <ShowBeneficiaryModal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    beneficiary={selectBeneficiary}
                  />
                </div>
              )}
              {isBeneficiaryEmpty && (
                <EmptyBeneficiary
                  addBeneficiaryModalOpen={addBeneficiaryModalOpen}
                  setaddBeneficiaryModalOpen={setaddBeneficiaryModalOpen}
                  setRefreshBeneficiary={setRefreshBeneficiary}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ManageBeneficiaries;
